import { render, staticRenderFns } from "./GroupsCreateUpdate.vue?vue&type=template&id=021bca00"
import script from "./GroupsCreateUpdate.vue?vue&type=script&lang=js"
export * from "./GroupsCreateUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('021bca00')) {
      api.createRecord('021bca00', component.options)
    } else {
      api.reload('021bca00', component.options)
    }
    module.hot.accept("./GroupsCreateUpdate.vue?vue&type=template&id=021bca00", function () {
      api.rerender('021bca00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/account/views/groups/GroupsCreateUpdate.vue"
export default component.exports